var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container calendar-list-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-select",
            {
              staticClass: "form-item-width",
              attrs: { clearable: "", placeholder: "请选择小区名称" },
              on: { change: _vm.areaChange },
              model: {
                value: _vm.listQuery.areaId,
                callback: function($$v) {
                  _vm.$set(_vm.listQuery, "areaId", $$v)
                },
                expression: "listQuery.areaId"
              }
            },
            _vm._l(_vm.areaList, function(item) {
              return _c("el-option", {
                key: item.areaId,
                attrs: { label: item.areaName, value: item.areaId }
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticClass: "form-item-width",
              attrs: { clearable: "", placeholder: "请选择仪表类型" },
              model: {
                value: _vm.listQuery.meterId,
                callback: function($$v) {
                  _vm.$set(_vm.listQuery, "meterId", $$v)
                },
                expression: "listQuery.meterId"
              }
            },
            _vm._l(_vm.meterTypeList, function(item) {
              return _c("el-option", {
                key: item.meterId,
                attrs: { label: item.meterName, value: item.meterId }
              })
            }),
            1
          ),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter }
            },
            [_vm._v(_vm._s(_vm.$t("button.search")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-circle-plus-outline" },
              on: { click: _vm.handleCreate }
            },
            [_vm._v(_vm._s(_vm.$t("button.add")))]
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "10px" },
              attrs: { icon: "el-icon-delete", type: "danger" },
              on: { click: _vm.handleDeletes }
            },
            [_vm._v(_vm._s(_vm.$t("button.delete")))]
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            "element-loading-text": "数据正在加载中...",
            border: "",
            stripe: "",
            fit: "",
            "highlight-current-row": ""
          },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "min-width": "120px",
              label: "仪表名称",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.shareMeterName))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "min-width": "120px",
              label: "小区名称",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.areaName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "min-width": "140",
              label: "公摊仪表类型"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.shareTypeName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", "min-width": "120px", label: "公摊方式" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.shareModeName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "min-width": "120px",
              label: "仪表类型",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.meterTypeName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              width: "180",
              "min-width": "140px",
              align: "center",
              label: "读数日期"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.readDate))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", "min-width": "120px", label: "读数" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.currentRead))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", "min-width": "120px", label: "倍率" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.meterPower))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", "min-width": "120px", label: "损耗率" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.meterWastageRate))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "min-width": "120px",
              label: "备注",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.meterRemark))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", "min-width": "120px", label: "可用状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.meterIsEnable === 1 ? "可用" : "不可用"
                        )
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              width: "270",
              label: _vm.$t("table.actions"),
              "class-name": "small-padding "
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(scope) {
                    return scope.row.meterIsEnable === 1
                      ? [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "mini",
                                plain: "",
                                icon: "el-icon-edit"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleUpdate(
                                    scope.row.shareMeterId
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("button.edit")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "mini",
                                plain: "",
                                icon: "el-icon-edit"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleChangeMeter(
                                    scope.row.shareMeterId
                                  )
                                }
                              }
                            },
                            [_vm._v("换表")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "danger",
                                size: "mini",
                                plain: "",
                                icon: "el-icon-delete"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleDelete(
                                    scope.row.shareMeterId
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("button.delete")))]
                          )
                        ]
                      : undefined
                  }
                }
              ],
              null,
              true
            )
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.listQuery.page,
              "page-sizes": [10, 20, 30, 50],
              "page-size": _vm.listQuery.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticStyle: { "margin-top": "-6vh" },
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            width: "900px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c("instrument-add", {
            attrs: {
              keyValue: _vm.meterId,
              "show-dialog": _vm.dialogFormVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogChangeVIsible,
            width: "1000px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogChangeVIsible = $event
            }
          }
        },
        [
          _c("change-meter", {
            attrs: {
              keyValue: _vm.meterId,
              "show-dialog": _vm.dialogChangeVIsible
            },
            on: { handCancle: _vm.handCancleChange }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }